<template></template>

<script>
import axios from "axios";
import moment from "moment";
import device from "device-uuid";
import _, { filter, result } from "lodash";

import { toRaw } from "vue";

import { handleError } from "../../helpers";
import { effectiveConcurrent, comparePrincipalCandidates, syncEnhancementConcurrency as syncEnhConcurrency, runsUnder667Scheme, combineDeterminateTotal, stirEnhancementDeterminate, isSixSevenSixEnhancement, effectiveSubordinateStirFactor } from "../../chargeControlHelpers";
// import { start } from "repl";
// import { emit } from 'process';

export default {
  name: "sharedComponent",

  data() {
    return {
      app_token: "",
      storageData: null,
      CrimeDataById: null,
      CrimeDataByIdLoading: true,
    };
  },

  methods: {},

  deviceUUID() {
    var uuid = new device.DeviceUUID().get();
    return uuid;
  },

  sleep(ms) {
    return new Promise((resolve) => {
      setTimeout(resolve, ms);
    });
  },

  setAppToken(app_token) {
    this.app_token = app_token;
  },

  isSubstitution(chg) {
    // console.log('*** IsSubstitution ***', chg);
    // return chg.Substitution == "Yes" ? true : false;
    return chg?.CrimeTypeId == 2;
  },

  getSubstitutionParent(charges, chg) {
    const parent = _.find(charges.data, function (obj) {
      return obj.Id < chg.Id && obj.CountNumber == chg.CountNumber && obj?.CrimeTypeId != 2;
    });

    //_.find(charges.data, function(o) { return o.age < 40; });

    return parent.Id;
  },

  getParentIndex(charges, parent_id) {
    const parent = _.find(charges.data, function (obj) {
      return obj.Id == parent_id;
    });

    if (parent !== undefined) {
      const index = _.indexOf(charges.data, parent);
      return index;
    }

    return -1;
  },

  async getCharges(caseId, app_token) {
    // console.log("GET CHARGES");
    let this_charges;
    let token = app_token;

    let charges = await axios

      .get(process.env.VUE_APP_ENDPOINT + "/api/cases/" + caseId + "/charges/populated", {
        // .get(process.env.VUE_APP_ENDPOINT + "/api/charges/CaseId/" + caseId, {
        headers: { Authorization: `Bearer ` + token },
      })
      /*.then(charges => {
                    if (charges.status == 200) {
                    // console.log('CHARGES::::', charges);
                        //this_onCalc(animate);
                        return charges;
                    }
                })
                .catch(error => {
                    console.error(error)
                    return {error:error}
                })*/
      .then((charges) => {
        // charges.data?.forEach((chg, index) => {
        // });
        return charges;
      })
      .catch((e) => console.log(e));

    // let settledCharges = await Promise.allSettled(chargesWithEnhMatches).then((sc) => {
    //   // console.log(sc);
    //   let scValues = sc.map((chg) => chg.value);

    //   // let ch = _.orderBy(scValues, ['CountNumber', 'Id'], ['asc', 'asc']);

    //   // console.log("*** sortedCharges ***", scValues);
    //   charges.data = scValues;

    //   return charges;
    // });
    // console.log("CHARGES IN GET CHARGE", charges);
    return charges;
  },

  async addEMGsToCharges(charges, app_token) {
    const distinctCrimeIds = [];
    charges.data.forEach((charge) => {
      if (!distinctCrimeIds.includes(charge.CrimeId)) {
        distinctCrimeIds.push(charge.CrimeId);
      }
    });
    for (const crimeId of distinctCrimeIds) {
      const emgs = await axios
        .get(
          process.env.VUE_APP_ENDPOINT + `/api/crimeEnhancementMatchGroup/getManyByCrimeId/${crimeId}`,

          {
            headers: {
              Authorization: `Bearer ` + localStorage.getItem("user_token"),
            },
          }
        )
        .then((result) => {
          // console.log("ENH MATCHES", result.data.data);
          return result?.data;
        })
        .catch(handleError);
      // console.log('emgs for Id: ', crimeId, emgs);
      charges.data.forEach((chg) => {
        if (chg.CrimeId == crimeId) {
          chg.EnhancementMatchGroups = emgs;
        }
      });
    }
  },

  async populateChargesInfo(charges, app_token) {
    // console.time()
    let token = app_token;
    let crimeIdArray = [];
    charges.data.forEach((chg) => {
      const foundIndex = crimeIdArray.findIndex((cc) => cc.CrimeId == chg.CrimeId);
      if (foundIndex == -1) {
        crimeIdArray.push({ CrimeId: chg.CrimeId });
      }
    });

    for (const chg of crimeIdArray) {
      // console.log(chg)

      await axios
        .post(
          process.env.VUE_APP_ENDPOINT + `/api/crimeCollateralConsequences/include`,
          {
            where: {
              CrimeId: chg?.CrimeId,
            },
            include: ["CollateralConsequence"],
          },
          {
            headers: {
              Authorization: `Bearer ` + localStorage.getItem("user_token"),
            },
          }
        )
        .then((results) => {
          const filteredCCs = results.data.filter((cc) => {
            return (
              cc.CollateralConsequenceId !== null &&
              cc.CollateralConsequence?.EndDate == null &&
              !cc.CollateralConsequence.Hide &&
              cc.CollateralConsequence?.CollateralConsequenceTypeId !== 14
            );
          });
          chg.ccArray = filteredCCs;
          return chg;
        })
        .catch(handleError);

      //   .then((descriptionResults) => {
      //     const data = descriptionResults?.data?.data[0];
      //     chg.SeriousLawText = data?.SeriousLawText;
      //     chg.ViolentLawText = data?.ViolentLawText;
      //     chg.cstrgpLawText = data?.cstrgpLawText;
      //     chg.cssgLawText = data?.cssgLawText;
      //     chg.ctstgLawText = data?.ctstgLawText;
      //     return chg;
      //   })
      //   .catch(handleError);
    }
    // console.log("CRIME ID ARRAY", crimeIdArray);
    for (const charge of charges.data) {
      const foundIndex = crimeIdArray.findIndex((cc) => cc.CrimeId == charge.CrimeId);
      if (foundIndex !== -1) {
        charge.ccArray = crimeIdArray[foundIndex].ccArray;
      }
      const strikeInfo = await this.getCrimeStrikeInfo(charge, charge.Date);
      this.formatChargeStrikeInfo(charge, strikeInfo);
    }
    // console.timeEnd()
    // console.log("CHARGES IN POPULATE CHARGE", charges);
    return charges;
  },

  async getCrimeStrikeInfo(crime, offenseDate) {
    // console.time()
    const strikeInfo = await axios
      .post(
        process.env.VUE_APP_ENDPOINT + "/api/crimes/strikeInfo",
        {
          offenseDate: offenseDate || null,
          crime: crime,
        },
        {
          headers: { Authorization: `Bearer ` + localStorage.getItem("user_token") },
        }
      )
      .then((res) => {
        // console.log(res)
        return res.data;
      })
      .catch(handleError);
    // console.timeEnd()
    return strikeInfo;
  },

  async formatChargeStrikeInfo(charge, strikeInfo) {
    // console.log(charge)
    charge.seriousGroupLawText = strikeInfo.seriousGroup[0]?.Description ?? charge.SeriousLawText;
    charge.violentGroupLawText = strikeInfo.violentGroup[0]?.Description ?? charge.ViolentLawText;
    charge.thirdStrikeTriggerGroupLawText = strikeInfo.thirdStrikeTriggerGroup[0]?.Description ?? charge.cstsgLawText;
    if (strikeInfo.strikeGroup[0]?.Description) {
      charge.strikeLawText = strikeInfo.strikeGroup[0]?.Description;
    } else {
      // console.log(charge.seriousGroupLawText, charge.violentGroupLawText)
      let strikeText = `
        A crime is a strike if it is either a serious or violent felony.<br /><br />${charge.seriousGroupLawText}<br /><br />${charge.violentGroupLawText}
        `;
      charge.strikeLawText = strikeText;
    }
  },

  // async getChargesCollaterals(caseId, app_token) {
  //   let token = app_token;
  //   // console.log(
  //   //   "addressurl:::",
  //   //   process.env.VUE_APP_ENDPOINT +
  //   //     "/api/chargesCollaterals?Column=CaseId&Value=" +
  //   //     caseId
  //   // );

  //   let populatedCharges = await axios
  //     .get(
  //       process.env.VUE_APP_ENDPOINT +
  //         "/api/chargesCollaterals/CaseId/" + caseId,
  //       {
  //         headers: { Authorization: `Bearer ` + token },
  //       }
  //     )
  //     .then(async (foundCharges) => {
  //       // console.log("CHARGES IN THE REFRESH FUNCTION", foundCharges);
  //       let charges = foundCharges;
  //       if (foundCharges.status == 200) {
  //         // console.log('CHARGESCollaterals::::', charges);
  //         //this_charges = charges;

  //         let ch = _.orderBy(charges.data, ["CountNumber", "Id"], ["asc", "asc"]);
  //         // console.log("*** getCharges ***", ch);
  //         // charges.data = ch;
  //         let chargesWithEnhMatches = [];
  //         charges.data.forEach((charge, index) => {
  //           // charges.data[index].IsSexRegistry = charge.IsSexRegistry;
  //           charges.data[index].SEX_CC_LawText = charge.SEX_CC_LawText;
  //           // charges.data[index].IsArsonRegistry = charge.IsArsonRegistry;
  //           charges.data[index].ARSON_CC_LawText = charge.ARSON_CC_LawText;
  //           // charges.data[index].IsGangRegistry = charge.IsGangRegistry;
  //           charges.data[index].GANG_CC_LawText = charge.GANG_CC_LawText;
  //           // charges.data[index].IsFirearmRegistry = charge.IsFirearmRegistry;
  //           charges.data[index].FIREARM_CC_LawText = charge.FIREARM_CC_LawText;
  //           // charges.data[index].IsVoteProhibition = charge.IsVoteProhibition;
  //           charges.data[index].VOTE_CC_LawText = charge.VOTE_CC_LawText;
  //           // charges.data[index].IsJuryProhibition = charge.IsJuryProhibition;
  //           charges.data[index].JURY_CC_LawText = charge.JURY_CC_LawText;
  //           // charges.data[index].IsDNADataBank = charge.IsDNADataBank;
  //           charges.data[index].DNA_CC_LawText = charge.DNA_CC_LawText;
  //           // charges.data[index].IsPC1170hProhibited = charge.IsPC1170hProhibited;
  //           charges.data[index].PC1170h_CC_LawText = charge.PC1170h_CC_LawText;
  //           charges.data[index].NumberOfStrikes = charge.NumberOfStrikes;
  //           charges.data[index].strikeLawText = charge.strikeLawText;

  //           chargesWithEnhMatches.push(
  //             axios
  //               .get(
  //                 process.env.VUE_APP_ENDPOINT + `/api/crimeEnhancementMatchGroup/getManyByCrimeId/${charge.CrimeId}`,
  //                 {
  //                   headers: {
  //                     Authorization: `Bearer ` + localStorage.getItem("user_token"),
  //                   },
  //                 }
  //               )
  //               .then((result) => {
  //                 charge.EnhancementMatchGroups = result.data
  //                 // This is a terrible hack to allow enhancement matching for violent/serious felonies
  //                 if (
  //                   (charge?.CrimeTypeId == 6 || charge?.CrimeTypeId == 2) &&
  //                   charge?.cvgIsViolent
  //                 ) {
  //                   // console.log("VIOLENT ENH");
  //                   charge.EnhancementMatchGroups.push({
  //                     CrimeId: charge.CrimeId,
  //                     EnhancementMatchGroupId: 43,
  //                   });
  //                 }
  //                 if (
  //                   (charge?.CrimeTypeId == 6 || charge?.CrimeTypeId == 2) &&
  //                   charge?.IsSerious
  //                 ) {
  //                   // console.log("SERIOUS ENH");
  //                   charge.EnhancementMatchGroups.push({
  //                     CrimeId: charge.CrimeId,
  //                     EnhancementMatchGroupId: 63,
  //                   });
  //                 }
  //                 return charge;
  //               })
  //           );
  //         });
  //         // console.log("CHARGESCollaterals::::", charges);
  //         // return charges;

  //         let settledCharges = await Promise.allSettled(chargesWithEnhMatches).then(
  //           (sc) => {
  //             // console.log(sc);
  //             let scValues = sc.map((chg) => chg.value);
  //             // let ch = _.orderBy(scValues, ['CountNumber', 'Id'], ['asc', 'asc']);

  //             // console.log("*** sortedCharges ***", scValues);
  //             charges.data = scValues;

  //             return charges;
  //           }
  //         );
  //         return settledCharges;
  //         //this_onCalc(false);
  //       }
  //     })
  //     .catch(handleError);
  //   return populatedCharges;
  // },

  getTriad(chg, termLength, termUnits) {
    let uom = "";

    if (
      (chg.NumberOfStrikes == "2+" && chg.CrimeType != "Conduct enhancement" && (chg.IsSerious || chg.IsViolent)) ||
      chg.IsIndeterminate == 1
    ) {
      if (termUnits == "365") uom = "y-L";
    } else {
      if (termUnits == "365") uom = "y";
    }

    if (termUnits == "30") uom = "m";
    if (termUnits == "1") uom = "d";

    if (termLength > 16 && uom == "m") {
      let termMonth = termLength;
      termMonth %= 12;

      let termYear = Math.floor(termLength / 12);

      if (termMonth > 0) termLength = termYear + "y" + " " + termMonth + "m";
      else termLength = termYear + "y";

      return termLength;
    }

    return termLength + uom;
  },

  async setTriadTerm(term, chg, event, app_token, current_case) {
    // chg.SelectedTerm = term;
    let ret = await this.postChargeFieldValue(chg.Id, "SelectedTerm", chg.SelectedTerm, app_token, current_case);
  },

  parseDays(chg, ndays) {
    var years = 0,
      months = 0,
      weeks = 0,
      days = 0,
      value = 0;

    value = ndays;

    years = value > 364 || value % 360 == 0 ? Math.floor(value / 360) : 0;
    value = years ? value - years * 360 : value;

    months = value >= 30 ? Math.floor((value % 360) / 30) : 0;
    value = months ? value - months * 30 : value;

    if (years == 0 && months == 0) {
      weeks = value >= 7 ? Math.floor((value % 360) / 7) : 0;
      value = weeks ? value - weeks * 7 : value;
    }

    if (years == 0 && months == 0) {
      days = value < 7 ? Math.floor((value % 360) % 7) : 0;
    }

    let y = "";

    y = `${years}y `;

    let m = `${months}m `;
    let w = `${weeks}w `;
    let d = `${days}d `;

    let exp = (years > 0 ? y : "") + (months > 0 ? m : "") + (weeks > 0 ? w : "") + (days > 0 ? d : "");

    if (value < 0) {
      exp = "LWOP";
    }
    // console.log("parseDays:::", years, months, weeks, days, exp, ndays)
    return {
      years: years,
      months: months,
      weeks: weeks,
      days: days,
      exp: exp,
    };
  },

  CZ(s) {
    if (s == null || s == "") {
      return "";
    } else {
      return s;
    }
  },

  Z(s) {
    if (s == null || s == 0) {
      return 0;
    } else {
      return s;
    }
  },
  //Returns true if value is null/empty
  isCZ(s) {
    if (s == null || s == "") {
      return true;
    }
  },

  isZ(s) {
    if (s == null || s == 0) {
      return 0;
    }
  },

  async getCrimeDataById(Id) {
    this.CrimeDataByIdLoading = true;
    this.CrimeDataById = null;

    let token = localStorage.getItem("user_token");
    let url = process.env.VUE_APP_ENDPOINT + `/api/crimes/${Id}`;

    // console.log('addressurl:::', url);

    if (token?.length > 0) {
      let crimes = await axios
        .get(url, {
          headers: { Authorization: `Bearer ` + token },
        })
        .then((data) => {
          this.CrimeDataById = data;
          // console.log("getCrimeDataById::::", this.CrimeDataById);
          return this.CrimeDataById;
        })
        .catch(handleError);
      // .finally((data ) => {
      //     this.CrimeDataById = data;
      //     this.CrimeDataByIdLoading = false;
      //     return this.CrimeDataById;
      // })
      return crimes;
    } else {
      throw "app_token is empty.";
      return "";
    }
  },

  async postChargeFieldValue(Id, field, value, app_token, current_case) {
    // console.log("posts charge field");
    // console.log('app_token:: here::' , app_token, Id, field, value, current_case);

    //let value = e.target.value;
    let token = app_token;
    let currentCase = current_case;

    let postdata = {
      Id: Id,
      [field]: value,
    };

    // console.log('postdata::',postdata,  { Authorization: `Bearer ` + token });

    return await axios
      .put(process.env.VUE_APP_ENDPOINT + `/api/charges/${Id}`, postdata, {
        headers: { Authorization: `Bearer ` + token },
      })
      .catch(handleError);
  },

  async postChargeField(this_app_token, Id, field, value) {
    // let value = e.target.value;

    let token = this_app_token;

    let postdata = {
      Id: Id,
      [field]: value,
    };

    // console.log('postdata::',postdata);

    return await axios
      .put(process.env.VUE_APP_ENDPOINT + `/api/charges/${Id}`, postdata, {
        headers: { Authorization: `Bearer ` + token },
      })
      .then((charges) => {})
      .catch(handleError);
  },

  ynm(int) {
    switch (int) {
      case 0:
        return "No";
      case 1:
        return "Probably Not";
      case 2:
        return "Maybe";
      case 3:
        return "Sometimes";
      case 4:
        return "Probably Yes";
      case 5:
        return "Yes";
    }
  },

  // parameters - (parentCharge, enhancement.EnhancementMatchGroups) to calculate conduct enh,
  // parameters - (false, enhancement.EnhancementMatchGroups, charges) to calculate status enh

  //chgToEnhance is the charge to enhance
  //enhancementMatches is the list of enhancement matches on the charge

  calculateEnhMatch(chgToEnhance, enhancementMatches, charges, chargeItself) {
    // console.log("calculateEnhMatch values: ", chgToEnhance, enhancementMatches, charges, chargeItself);
    let isMatch = false;
    let childEnhancements;
    if (charges?.length > 0) {
      let filteredEnhs = charges.filter(
        (chg) =>
          (chgToEnhance === false || chg.CountNumber == chgToEnhance.CountNumber) &&
          chg.ChargeStatus !== 1 &&
          chg.ChargeStatus !== 2 &&
          (chg.CrimeTypeId == 6 || chg.CrimeTypeId == 2) &&
          chg?.Id !== chargeItself?.Id
      );
      // console.log(filteredEnhs);
      const mappedEnhMatchObjs = filteredEnhs.map((enh) =>
        enh.EnhancementMatchGroups.map((emg) => emg.EnhancementMatchGroupId)
      );
      childEnhancements = mappedEnhMatchObjs;
    } else {
      childEnhancements = [];
    }
    // console.log('CHILD ENHs', childEnhancements)

    //If there are enh matches
    if (enhancementMatches?.length > 0) {
      if (chgToEnhance !== false && chgToEnhance?.ChargeStatus == 0) {
        // List of enh match group ids on the charges to the actual enh
        let chgEnhMatchesMapped = chgToEnhance.EnhancementMatchGroups.map((emg) => emg.EnhancementMatchGroupId);

        // Finds all the other enhancements attached to the same count as this crime
        const enhancementsOnCrimeToEnhance = charges?.filter(
          (chg) =>
            chg.CountNumber == chgToEnhance.CountNumber &&
            chg.CrimeTypeId !== 5 &&
            chg.ChargeStatus == 0 &&
            chg.Id !== chargeItself?.Id
        );

        //If there are any other enh's attached to the same count as this enh, add them to the list
        if (enhancementsOnCrimeToEnhance?.length > 0) {
          enhancementsOnCrimeToEnhance.forEach((e) => {
            e.EnhancementMatchGroups.forEach((emg) => {
              // console.log(emg)
              if (!chgEnhMatchesMapped.includes(emg)) {
                chgEnhMatchesMapped.push(emg?.EnhancementMatchGroupId);
              }
            });
          });
        }

        // Loop through all enhancement matches
        enhancementMatches.forEach((enhMatch) => {
          // Look through the enhancements that are matched to the charge and make sure the charge applies to attempts
          if (
            chgEnhMatchesMapped.includes(enhMatch.EnhancementMatchGroupId) &&
            (chgToEnhance.CrimeState != "Attempt" || enhMatch.AppliesToAttempts == true || 
              chgToEnhance.EnhancementMatchGroups.findIndex((parentEMG => parentEMG.EnhancementMatchGroupId == enhMatch.EnhancementMatchGroupId && parentEMG.AppliesToAttempts == true)) != -1
            )
          ) {
            // console.log("chgToEnhance.CrimeState: ", chgToEnhance.CrimeState);
            // console.log("enhMatch.AppliesToAttempts: ", enhMatch.AppliesToAttempts);

            isMatch = true;
            // }
            // console.log("isMatch: ", isMatch);

            // // console.log("enh:", enhMatch);

            // // console.log("chg:", chgEnhMatchesMapped);
            // else if (chgEnhMatchesMapped.includes(enhMatch.EnhancementMatchGroupId)) {
            //   // console.log('BING')
            //   // console.log(enhMatch)
            //   // console.log(chgEnhMatchesMapped)
            //   isMatch = true;
          }
        });
      } else if (charges?.length > 0) {
        let chgEnhMatchesMapped = [];
        if (chgToEnhance && chgToEnhance.EnhancementMatchGroups) {
          chgEnhMatchesMapped = chgToEnhance.EnhancementMatchGroups.map((emg) => emg.EnhancementMatchGroupId);
        }
        // console.log('Status Enhancement Check')
        let chargesEnhancementMatchesArray = [];
        charges.forEach((charge) => {
          charge.EnhancementMatchGroups.forEach((emg) => {
            if (!chargesEnhancementMatchesArray.includes(emg) && charge.CrimeTypeId !== 1 && charge.ChargeStatus == 0) {
              chargesEnhancementMatchesArray.push(emg.EnhancementMatchGroupId);
            }
          });
        });
        // console.log('TOTAL CHARGES EMGS', chargesEnhancementMatchesArray)
        enhancementMatches.forEach((enhMatch) => {
          if (
            chargesEnhancementMatchesArray.includes(enhMatch.EnhancementMatchGroupId) ||
            childEnhancements?.includes(enhMatch.EnhancementMatchGroupId)
          ) {
            // console.log('BING')

            isMatch = true;
          } else if (
            chgEnhMatchesMapped.length > 0 &&
            chgEnhMatchesMapped.includes(enhMatch.EnhancementMatchGroupId) &&
            (chgToEnhance.CrimeState !== "Attempt" || enhMatch.AppliesToAttempts === true)
          ) {
            isMatch = true;
          } else {
            // console.log(
            //   "MISMATCH MISMATCH MISMATCH",
            //   enhMatch,
            //   chargesEnhancementMatchesArray
            // );
          }
        });
      }
    } else {
      isMatch = true;
    }
    return isMatch;
  },

  // async populateCrimesCC(crimesArray) {
  //   const token = localStorage.getItem("user_token");

  //   if (crimesArray.length > 0) {
  //     let populatedArray = [];
  //     crimesArray.forEach(async (crime) => {
  //       populatedArray.push(
  //         axios
  //           .post(
  //             process.env.VUE_APP_ENDPOINT + "/api/crimeCollateralConsequences/include",
  //             {
  //               where: {
  //                 CrimeId: crime.Id,
  //               },
  //               include: ["CollateralConsequence"],
  //             },
  //             {
  //               headers: {
  //                 Authorization: "Bearer " + token,
  //               },
  //             }
  //           )
  //           .then(async (results) => {
  //             // console.log(results.data)
  //             let popCrime = crime;
  //             popCrime.ccArray = await results.data
  //               .filter((ccObj) => ccObj.CollateralConsequenceId !== null)
  //               .map((ccObj) => ccObj.CollateralConsequence);
  //             return popCrime;
  //           })
  //       );
  //     });
  //     let completedCrimes = await Promise.allSettled(populatedArray);
  //     // console.log(completedCrimes);
  //     let returnCharges = completedCrimes.map((crm) => crm.value);
  //     return returnCharges;
  //   } else {
  //     return [];
  //   }
  // },

  async calculateExposure(charges) {
    charges.map((chg) => {
      let tomsExposureObject = {};
      if (chg.SelectedTerm == 3) {
        tomsExposureObject.exposureDays = chg.UpperTermUnits * chg.UpperTermLength;
      } else if (chg.SelectedTerm == 2) {
        tomsExposureObject.exposureDays = chg.MiddleTermUnits * chg.MiddleTermLength;
      } else {
        tomsExposureObject.exposureDays = chg.LowerTermUnits * chg.LowerTermLength;
      }
      chg.tomsExposureObject = tomsExposureObject;
      // console.log(tomsExposureObject)
      return chg;
    });
    // console.log(charges[0])
    charges.sort((a, b) => b.tomsExposureObject.exposureDays - a.tomsExposureObject.exposureDays);
    // console.log(charges[0].tomsExposureObject.exposureDays)
  },

  enhancementSweep(charges) {
    // console.log(charges)
    let notifications = [];
    if (charges?.length > 0) {
      charges.forEach((charge) => {
        if (charge.CrimeTypeId == 5) {
          charge.EnhancedSerious = charge.IsSerious;
          charge.EnhancedViolent = charge.IsViolent;
          charge.EnhancedThirdStrikeTrigger = charge.IsThirdStrikeTrigger;
          charge.EnhancedSuperStrike = charge.IsSuperStrike;
        }

        //If enh is a status enhancement and is Convicted
        if (charge?.CrimeTypeId == 1 && charge.ChargeStatus == 0) {
          //Check the enhancement match groups associated with the charges
          let matchValue = this.calculateEnhMatch(false, charge.EnhancementMatchGroups, charges);
          if (matchValue === false) {
            // notifications.push(
            //   `There are no charges matching ${charge.SectionNumber}'s requirements'`
            // );
            //Stay the charge
            charge.ChargeStatus = 4;
            charge.newExposureObject?.ruleWords?.push(
              "This enhancement has been stayed because the conditions for this charge to apply have not been met."
            );
            charge.newExposureObject?.ruleWordsIds?.push(20);

            //If enh match and enh is stayed
          } else if (matchValue === true && charge.ChargeStatus == 4) {
            // notifications.push(
            //   `${charge.SectionNumber}'s requirements have been met and it has been changed to Convicted`
            // );
            //Change the enh to convicted
            charge.ChargeStatus = 0;
            charge.newExposureObject?.ruleWords?.push(
              `This enhancement has been changed to convicted because it's triggering condition has been satisfied`
            );
            charge.newExposureObject?.ruleWordsIds?.push(22);
          }
          //If enh is a conduct enhancement or Special Allegation and is not acquitted or dismissed
        } else if (
          (charge?.CrimeTypeId == 6 || charge?.CrimeTypeId == 2) &&
          charge.ChargeStatus !== 1 &&
          charge.ChargeStatus !== 2
        ) {
          let parentCharge = charges.find(
            (element) => element.CountNumber == charge.CountNumber && element.CrimeTypeId == 5
          );
          charge.parentCharge = parentCharge;
          let matchValue = false;

          if (parentCharge !== undefined) {
            // console.log(parentCharge);
            matchValue =
              this.calculateEnhMatch(parentCharge, charge.EnhancementMatchGroups, charges, charge) &&
              // A conduct enh cannot be added to a parent charge if the concurrencies differ
              /* Mustafaa rule */
              parentCharge.newExposureObject?.concurrent == charge.newExposureObject?.concurrent;
            if (parentCharge.newExposureObject?.concurrent !== charge.newExposureObject?.concurrent) {
              notifications?.push(`${charge.SectionNumber} cannot be attached to a Concurrent charge`);
              charge.newExposureObject?.ruleWords?.push(
                `This enhancement has been stayed because it has been attached to a concurrently sentenced charge,
                but this crime requires it to be attached to a consecutively charged crime.`
              );
              charge.newExposureObject?.ruleWordsIds?.push(21);
            } else if (!this.calculateEnhMatch(parentCharge, charge.EnhancementMatchGroups, charges, charge)) {
              notifications.push(
                `${charge.SectionNumber} cannot be attached to a ${parentCharge.SectionNumber} charge by definition`
              );
              charge.newExposureObject?.ruleWords?.push(
                "This enhancement has been stayed because the conditions for this charge to apply have not been met."
              );
              //If the parent charge is not convicted and enhancement is convicted, stay the charge
            } else if (parentCharge?.ChargeStatus != 0 && charge.ChargeStatus == 0) {
              // charge.ChargeStatus = parentCharge?.ChargeStatus;
              charge.ChargeStatus = 4;
              // notifications.push(
              //   `${charge.SectionNumber} cannot be attached to a ${parentCharge.SectionNumber} charge by definition`
              // );
              // charge.newExposureObject?.ruleWords?.push(
              //   "This enhancement has been stayed because the conditions for this charge to apply have not been met."
              // );
            }
          }

          // enhancement is not a match
          if (matchValue === false) {
            // stay the charge
            charge.ChargeStatus = 4;
            // if (parentCharge) {
            //   parentCharge.EnhancedSerious = parentCharge?.IsSerious;
            //   parentCharge.EnhancedViolent = parentCharge?.IsViolent;
            // }
            //if the enh is a match and it's stayed and there is a parent charge that is convicted, set the enh to convicted
          } else if (matchValue === true && charge.ChargeStatus == 4 && parentCharge && parentCharge?.ChargeStatus == 0) {
            charge.ChargeStatus = 0;
          }
          //if the enh is a match and the parent is not serious and the charge is serious, make the parent serious
          if (matchValue == true && !parentCharge.IsSerious && charge.IsSerious) {
            parentCharge.newExposureObject?.ruleWords?.push(
              "This felony is classified as serious because it has been enhanced with a charge that is classified as a serious felony"
            );
            parentCharge.EnhancedSerious = true;
            // console.log('becomes serious', parentCharge)
          }
          //if enh is a match and parent is not violent but enh is violent, make the parent violent
          if (matchValue == true && !parentCharge.IsViolent && charge.IsViolent) {
            parentCharge.newExposureObject?.ruleWords?.push(
              "This felony is classified as violent because it has been enhanced with a charge that is classified as a violent felony"
            );
            parentCharge.EnhancedViolent = true;
            // console.log('becomes violent', parentCharge)
          }

          if (matchValue == true && !parentCharge.IsThirdStrikeTrigger && charge.IsThirdStrikeTrigger) {
            parentCharge.newExposureObject?.ruleWords?.push(
              "This felony is classified as a third strike because it has been enhanced with a charge that is classified as a third strike"
            );
            parentCharge.EnhancedThirdStrikeTrigger = true;
            
          }
          //if enh is a match and parent is not super strike but enh is super strike, make the parent super strike
          if (matchValue == true && !parentCharge.IsSuperStrike && charge.IsSuperStrike) {
            parentCharge.newExposureObject?.ruleWords?.push(
              "This felony is classified as a super strike because it has been enhanced with a charge that is classified as a super strike"
            );
            parentCharge.EnhancedSuperStrike = true;
          }
        }
      });
    }
    // console.log(notifications);
    return notifications;
  },

  sortCharges(charges, user_token) {
    let preSorted = [];
    charges.forEach((chg) => [
      preSorted.push({
        Id: chg.Id,
        CountNumber: chg.CountNumber,
      }),
    ]);
    // console.log('SORTS')
    // console.log("CHARGES BEFORE", charges);
    charges = charges.sort((a, b) => {
      if (a.CountNumber == b.CountNumber) {
        // console.log('ENH DOWN')
        if (a.CrimeTypeId !== 5 && b.CrimeTypeId == 5) {
          return 1;
        } else if (a.CrimeTypeId == 5 && b.CrimeTypeId !== 5) {
          return -1;
        } else if (a.CrimeTypeId !== 5 && b.CrimeTypeId !== 5) {
          return a.SectionNumber - b.SectionNumber;
        }
      } else {
        return a.CountNumber - b.CountNumber;
      }
    });
    let countNumberChecker = 1;
    for (let i = 0; i < charges.length; i++) {
      let chg = charges[i];

      // console.log(chg)
      // console.log(chg.CountNumber)
      // console.log(countNumberChecker)
      if (chg.CrimeTypeId == 1 || chg.CrimeTypeId == 6 || chg.CrimeTypeId == 2) {
        continue;
      } else if (chg.CrimeId !== 0) {
        // if (chg.CountNumber != countNumberChecker) {
        //     const offBy = chg.CountNumber - countNumberChecker;
        //     // console.log('OFF BY', offBy, i)
        //     for (let j = i; j < charges.length; j++) {
        //         // console.log(charges[j].CountNumber)
        //         charges[j].CountNumber -= offBy
        //     }
        // }
        countNumberChecker++;
      }
    }

    // charges.forEach(chg => {
    //     let before = preSorted.find(oldChg => oldChg.Id == chg.Id);
    //     if (before.CountNumber !== chg.CountNumber) {
    //         this.postChargeFieldValue(chg.Id, 'CountNumber', chg.CountNumber, user_token, chg.CaseId)
    //     }
    // })
    // console.log('CHARGES AFTER', charges)
  },

  setExposureObject(charges) {
    charges.forEach((charge) => {
      charge.newExposureObject = null;
      // Attempt/Conspiracy charges are sentenced as normal crimes (1/3 of the middle term),
      // never under the 667.6 full-term scheme, so normalize the effective subordinate STIR
      // factor to 3. This makes the whole app (Sentencing Scheme display + subordinate calc)
      // treat them as normal crimes.
      charge.SubordinateSTIRFactor = effectiveSubordinateStirFactor(charge);
      let CrimeState = charge.CrimeState;
      let days = 0;
      let units = 0;

      let determinate = 0;
      let indeterminate = 0;
      let modifiedTriad = [];
      let jcredit = parseInt(charge.JailCreditPercentageName);
      let pcredit = parseInt(charge.PrisonCreditPercentageName);
      let lowerTermLength = charge.LowerTermLength;
      let lowerTermUnits = charge.LowerTermUnits == 365 ? 360 : charge.LowerTermUnits;
      let specialIndet = false;
      let minJailTime = charge?.MinimumProbationJailTimeLength * charge?.MinimumProbationJailTimeUnits;
      let maxJailTime = charge?.MaximumProbationJailTimeLength * charge?.MaximumProbationJailTimeUnits;
      if (charge.IsLWOP && charge.CrimeTypeId !== 2 && charge.CrimeState !== "Attempt" && charge.ChargeStatus == 0) {
        specialIndet = "LWOP";
      }
      if (
        charge.IsDeath &&
        charge.CrimeTypeId !== 2 &&
        charge.CrimeState !== "Attempt" &&
        charge.ChargeStatus == 0 &&
        charge.SelectedTerm == 3
      ) {
        specialIndet = "DEATH";
      }
      let middleTermLength = charge.MiddleTermLength;
      let middleTermUnits = charge.MiddleTermUnits == 365 ? 360 : charge.MiddleTermUnits;
      let upperTermLength = charge.UpperTermLength;
      let upperTermUnits = charge.UpperTermUnits == 365 ? 360 : charge.UpperTermUnits;
      if (CrimeState == "Attempt") {
        // if (charge.AttemptSpecial == 2) {
        //   lowerTermLength = 0;
        //   lowerTermUnits = 30;
        //   middleTermLength = 0;
        //   middleTermUnits = 30;
        //   upperTermLength = 180;
        //   upperTermUnits = 30;
        // } else if (charge.AttemptSpecial == 1) {
        //   // specialIndet = 'LWOP'
        //   lowerTermLength = 0;
        //   lowerTermUnits = 30;
        //   middleTermLength = 0;
        //   middleTermUnits = 30;
        //   upperTermLength = 84;
        //   upperTermUnits = 30;
        // } else {
        //   lowerTermLength = charge.LowerTermLength;
        //   lowerTermUnits = charge.LowerTermUnits;
        //   middleTermLength = charge.MiddleTermLength;
        //   middleTermUnits = charge.MiddleTermUnits;
        //   upperTermLength = charge.UpperTermLength;
        //   upperTermUnits = charge.UpperTermUnits;
        // }
        if (pcredit == 0) {
          pcredit = 15;
        } else {
          pcredit = 50;
        }
      }

      const exposureObject = {
        triad: [lowerTermLength * lowerTermUnits, middleTermLength * middleTermUnits, upperTermLength * upperTermUnits],
        determinate: 0,
        indeterminate: 0,
        specialIndeterminate: specialIndet,
        isPrincipal: null,
        ruleWords: [],
        ruleWordsIds: [],
        populatedRuleWords: [],
        jcredit: jcredit,
        pcredit: pcredit,
        minJailTime: minJailTime,
        maxJailTime: maxJailTime,
        concurrent: false,
      };
      if (charge.CrimeState == "Attempt" && charge.AttemptSpecial !== 1) {
        exposureObject.ruleWords.push("Because this crime has been charged as an attempt, it carries a reduced sentence.");
        exposureObject.ruleWordsIds.push(23);
      }
      charge.newExposureObject = exposureObject;
    });
  },

  threeStrikeFormula(charges) {
    // console.log('3sl Charges', charges)
    let notifications = [];
    // console.log('THREE STRIKES BEFORE ALGO', charges)
    charges.forEach((element) => {
      // console.log(element);
      // let obj = JSON.parse(JSON.stringify(attr));
      let days = 0;
      let units = 0;

      // let determinate = element.newExposureObject.determinate
      // let indeterminate = element.newExposureObject.indeterminate
      if (element.SelectedTerm) {
        switch (element.SelectedTerm) {
          case 1:
            days = element.newExposureObject.triad[0];
            // units = lowerTermUnits;
            break;
          case 2:
            days = element.newExposureObject.triad[1];
            // units = middleTermUnits;
            break;
          case 3:
            days = element.newExposureObject.triad[2];
            // units = upperTermUnits;
            break;
        }
      } else {
        switch (element.SubordinateSTIRTerm) {
          case 1:
            days = element.newExposureObject.triad[0];
            // units = lowerTermUnits;
            break;
          case 2:
            days = element.newExposureObject.triad[1];
            // units = middleTermUnits;
            break;
          case 3:
            days = element.newExposureObject.triad[2];
            // units = upperTermUnits;
            break;
        }
      }

      if (element.newExposureObject.indeterminate > 0) {
        days = element.newExposureObject.indeterminate;
      }

      /* Handles Misds, Infractions, No Strikes, and 1 Prior Strike + 1 Current Strike */
      //  if (element.CrimeTypeId == 2) {
      //   const parentCharge = charges.find(chg => chg.CountNumber == element.CountNumber && chg.CrimeTypeId == 5);
      //   if (parentCharge && parentCharge.CrimeSeverityId == 2) {
      //     parentCharge.newExposureObject.determinate *= 2

      //   }
      // } else
      if (
        element.NumberOfStrikes == "0" ||
        element.NumberOfStrikes == "1" ||
        element.CrimeSeverityId == 1 ||
        (element.CrimeSeverityId == 2 && !this.isMisdemeanorSubstitutedToAFelony(element, charges)) ||
        element.CrimeTypeId == 1 ||
        // element.CrimeTypeId == 2 ||
        element.CrimeTypeId == 6
      ) {
        /* Doubles on 2nd Strike */

        if (
          element.NumberOfStrikes == "1" &&
          (element.CrimeSeverityId == 3 ||
            (element.CrimeSeverityId == 2 && this.isMisdemeanorSubstitutedToAFelony(element, charges))) &&
          element.CrimeTypeId == 5
          // &&
          // (element.IsSerious ||
          //   element.cvgIsViolent ||
          //   element.EnhancedSerious ||
          //   element.EnhancedViolent)
        ) {
          element.newExposureObject.ruleWords.push("Sentence is doubled per ");
          element.newExposureObject.triad[0] *= 2;
          element.newExposureObject.triad[1] *= 2;
          element.newExposureObject.triad[2] *= 2;
          days *= 2;
          if (this.isIndeterminate(element)) {
            element.newExposureObject.ruleWordsIds.push(13);
            element.newExposureObject.ruleWords
              .push(`Because the defendant has one prior strike the minimum term for an indeterminate term is twice the term otherwise provided as punishment. [PC 667(e)(1)  PC 1170.12(c)(1)  People v Bolden (1999) 71 Cal.App.4th 730]
                        Defined life terms (xx to Life) generally have a statutory earliest release date (ERD).  However, whenever other statutes limit available credits against a sentence, the most restrictive calculation is used to arrive at the actual ERD.
                        Defined life terms have an ERD which is determined by 1) calculating the statutory minimum eligible parole date  2) calculating any limitations on credits against the low end of the sentence imposed  and then 3) choosing the calculation which results in the longer period of incarceration.  Most defined life terms have an ERD calculated at 85 percent or 100 percent of the low end.
                        Note:  When a defendant is committed to prison on a life sentence which is ordered to run consecutive to any inderterminate term the determinate terms shall be served first and no part thereof shall be credited toward the person's ERD.  [PC 669]`);
          } else {
            element.newExposureObject.ruleWords.push(`Sentencing After Proposition 36

Defendant is sentenced pursuant PC 1170.12(c)(1) [1 prior strike sentencing] because the instant offenses are not serious or violent felonies or third strike triggers [PC 1170.12(c)(2)(C)(i)-(iii)] and defendant's prior strikes do not qualify as super strikes [PC 1170.12(c)(2)(C)(iv)].

Because this offense is designated as the principal term, and the defendant has one prior strike,  the court may impose the full upper term doubled.  [PC 1170(a)(3)]

For exposure purposes, the principal term consists of the greatest term of imprisonment which may be imposed for any of the determinate crimes, including certain enhancements.  [PC 1170.1(a)]

If a defendant has one prior strike, the determinate term shall be twice the term otherwise provided as punishment.  [PC 667(e)(1) and PC 1170.12(c)(1)  People v McKee (1995) 36 Cal.App.4th 540  People v Martin (1995) 32 Cal.App.4th 656]`);
          }
          if (element.newExposureObject.pcredit > 20) {
            element.newExposureObject.pcredit = 20;
          }
        }
        // modifiedTriad.push(lowerTermDays);
        // modifiedTriad.push(middleTermDays);
        // modifiedTriad.push(upperTermDays);
        if (this.isIndeterminate(element)) {
          element.newExposureObject.indeterminate = days;
        } else if (element.CrimeTypeId != 2) {
          // console.log('MISD SETTER', element.CountNumber, days)
          // console.log(days)

          element.newExposureObject.determinate += days;
        }
        /* Third Strike Law */
      } else if (element.NumberOfStrikes == "2+" || element.NumberOfStrikes == "2+!") {
        if (element.newExposureObject.pcredit > 20) {
          element.newExposureObject.pcredit = 20;
        }
        if (element.CrimeTypeId == 2) {
        } else if (this.isStrike(element) || element.IsThirdStrikeTrigger || element.EnhancedThirdStrikeTrigger || element.NumberOfStrikes == "2+!") {
          // let tempTriad = [lowerTermDays, middleTermDays, upperTermDays];
          let tempTriad = element.newExposureObject.triad;
          let bonusPoints = 0;
          let finalTriad = [];
          charges.forEach((enh) => {
            if (
              enh.ChargeStatus == 0 &&
              (enh.CrimeTypeId == 1 || (enh.CrimeTypeId == 6 && enh.CountNumber == element.CountNumber))
            ) {
              switch (enh.SelectedTerm) {
                case 1:
                  bonusPoints += enh.LowerTermLength * enh.LowerTermUnits;
                  break;
                case 2:
                  bonusPoints += enh.MiddleTermLength * enh.MiddleTermUnits;
                  break;
                case 3:
                  bonusPoints += enh.UpperTermLength * enh.UpperTermUnits;
                  break;
              }
            }
          });
          element.newExposureObject.dotsonOptions = {
            option1Triad: [],
            option2Triad: [],
            option3Triad: [],
          };
          element.newExposureObject.triad.forEach((term, index) => {
            // console.log('TRIGGERS TST')
            // console.log(term);
            /* LOOP THROUGH TRIAD AND CALC EACH OPTION */
            if (term > 0) {
              let option1 = 3 * term;
              let option2 = 25 * 360;
              let option3 = term + bonusPoints;
              element.newExposureObject.dotsonOptions.option1Triad.push(option1);
              element.newExposureObject.dotsonOptions.option2Triad.push(option2);
              element.newExposureObject.dotsonOptions.option3Triad.push(option3);
              /* Adds Enhancement Exposure for Option 3 */
              // console.log('TST OPTIONS,', option1, option2, option3)
              if (option2 >= option1 && option2 >= option3) {
                if (index + 1 == element.SelectedTerm) {
                  element.newExposureObject.ruleWords.push(
                    `Because this crime qualifies for Third Strike Sentencing under PC 1170.12, the term that carries the longest sentence is 25 Years to Life per 1170.12(c)(2)(A)(ii).`
                  );
                }
                finalTriad.push(option2);
              } else if (option3 >= option2 && option3 >= option1) {
                if (index + 1 == element.SelectedTerm) {
                  element.newExposureObject.ruleWords.push(
                    `Because this crime qualifies for Third Strike Sentencing under PC 1170.12, the term that carries the longest sentence is ${
                      option3 / 360
                    } Years to Life per 1170.12(c)(2)(A)(iii).`
                  );
                  if (bonusPoints > 0) {
                    element.newExposureObject.ruleWords.push(
                      `Because PC 1170.12 is classified as an alternative sentencing schema, the additional sentence provided by the application of enhancements for this charge aren't considered to be a dual use of enhancements, and are thus applied separately from their application under PC 1170.1(d).`
                    );
                  }
                }
                finalTriad.push(option3);
              } else if (option1 >= option2 && option1 >= option3) {
                if (index + 1 == element.SelectedTerm) {
                  element.newExposureObject.ruleWords.push(
                    `Because this crime qualifies for Third Strike Sentencing under PC 1170.12, the term that carries the longest sentence is ${
                      option1 / 360
                    } Years to Life per 1170.12(c)(2)(A)(i).`
                  );
                }
                finalTriad.push(option1);
              }
            } else if (term === 0) {
              finalTriad.push(0);
            } else if (term < 0) {
              finalTriad.push(term);
            }
          });

          // modifiedTriad = finalTriad;
          // console.log(finalTriad)
          days = finalTriad[element.SelectedTerm - 1];
          element.newExposureObject.indeterminate = days;
          element.newExposureObject.triad = finalTriad;
        } else {
          element.newExposureObject.ruleWords.push(
            `Even though this felony isn't a violent or serious crime, because the defendant has 2 or more prior strike convictions, this charge's sentence is doubled as if it were a second strike per PC 1170.12(c)(2)(C).`
          );
          element.newExposureObject.triad[0] *= 2;
          element.newExposureObject.triad[1] *= 2;
          element.newExposureObject.triad[2] *= 2;
          days *= 2;
          // modifiedTriad.push(lowerTermDays);
          // modifiedTriad.push(middleTermDays);
          // modifiedTriad.push(upperTermDays);
          if (element.newExposureObject.indeterminate > 0 || element.IsIndeterminate || element.IsLWOP || element.IsDeath) {
            element.newExposureObject.indeterminate = days;
          } else {
            element.newExposureObject.determinate += days;
          }
        }
      }
      // console.log('THREE STRIKES AFTER ALGO', charges)
      // console.log('TRIAD:', modifiedTriad);
      // console.log('DAYS', days)
      // console.log('determinate', determinate)
      // console.log('indeterminate', indeterminate)
      // console.log(element)
      // let newExposureObject = {
      //     triad: modifiedTriad,
      //     determinate: determinate,
      //     indeterminate: indeterminate
      // }
      // element.newExposureObject = newExposureObject
      // console.log(element.SectionNumber, newExposureObject)
    });
  },

  getPrincipalCharge(charges) {
    let combinedCountArray = [];
    let principalTies = [];
    charges.forEach((charge, index) => {
      if (
        (charge.CrimeSeverityId == 1 ||
          (charge.CrimeSeverityId == 2 && !this.isMisdemeanorSubstitutedToAFelony(charge, charges))) &&
        (charge.CrimeTypeId == 5 || charge.CrimeTypeId == 6)
      ) {
        charge.newExposureObject.ruleWords.push(
          `Because this crime isn't a felony, it is not subject to the 1/3 the Middle Term rule under PC 1170.1(a).`
        );
        charge.newExposureObject.ruleWordsIds.push(charge.CrimeSeverityId == 1 ? 1 : 2);
        // console.log('sees a misd', index)
        charge.newExposureObject.isPrincipal = 4;
      } else if (charge.CrimeTypeId == 1 || charge.CrimeTypeId == 2 || charge.CrimeTypeId == 3) {
        // console.log('sees a se', index)
        charge.newExposureObject.isPrincipal = 3;
      } else if (this.isIndeterminate(charge)) {
        // console.log('sees an ind', index)
        charge.newExposureObject.isPrincipal = 2;
      } else if (
        charge.ChargeStatus == 0 &&
        charge.CrimeTypeId == 5 &&
        // A charge running the PC 667.6 full-term scheme is excluded from principal
        // candidacy (isPrincipal 6) so it can't take over the principal on exposure.
        // Keyed off the live RunSTIRCalculation toggle, so switching back to PC 1170.1(a)
        // makes it a normal candidate again. (Previously dormant — RunSTIRCalculation was
        // misspelled inline.)
        runsUnder667Scheme(charge, charges)
      ) {
        charge.newExposureObject.isPrincipal = 6;
      } else if (charge.ChargeStatus == 0) {
        charge.newExposureObject.indeterminate = 0;
        // console.log('SEES A DETERMINATE CHARGE', index)
        if (charge.CrimeTypeId == 5) {
          combinedCountArray.push({
            countNumber: charge.CountNumber,
            determinate: charge.newExposureObject.determinate,
            IsPrincipal: charge.IsPrincipal,
            Concurrency: charge.Concurrency,
          });
          // console.log(combinedCountArray)
        } else if (charge.CrimeTypeId == 6) {
          // console.log(charge.CountNumber)
          let correctIndex = combinedCountArray.findIndex((count) => count.countNumber == charge.CountNumber);
          // console.log(correctIndex)
          if (correctIndex != -1) {
            combinedCountArray[correctIndex].determinate += charge.newExposureObject.determinate;
          } else {
            if (charge?.parentCharge?.RunSTIRCalculation == true && charge.parentCharge.SubordinateSTIRTerm == 3) {
              charge.newExposureObject.isPrincipal = 6;
            } else {
              charge.newExposureObject.isPrincipal = 2;
            }
          }
        } else {
          // console.log("BING BONG");
        }
      }
      // console.log(charge.newExposureObject.isPrincipal)
    });
    console.log("CCA", combinedCountArray);
    if (combinedCountArray.length > 0) {
      // Rank tied charges to pick the principal. The user's Preferred (IsPrincipal)
      // selection outranks Concurrency, so a currently-concurrent charge can be made
      // the principal (it then calculates/displays as consecutive).
      let sortedArray = combinedCountArray.sort(comparePrincipalCandidates);

      let principalCountNumber = sortedArray[0].countNumber;
      let minConcurrency = false;

      charges.forEach((charge, index) => {
        if (
          charge.CrimeTypeId !== 1 &&
          charge.newExposureObject.indeterminate == 0 &&
          !this.isIndeterminate(charge) &&
          charge.newExposureObject.isPrincipal == undefined
        ) {
          if (charge.CountNumber == principalCountNumber) {
            charge.newExposureObject.isPrincipal = 1;
            charge.newExposureObject.ruleWords.push(
              "This charge carries the greatest selected term of incarceration among determinate felonies, and is subject to the sentence perscribed by the full selected term."
            );
            charge.newExposureObject.ruleWordsIds.push(4);
            // if (!minConcurrency && charge.CountNumber == principalCountNumber) {
            //   charge.Concurrency = 0;
            // }
          } else {
            charge.newExposureObject.isPrincipal = 0;
            if (charge?.RunSTIRCalculation != true) {
              // if (charge.SubordinateSTIRFactor == 3) {
              charge.newExposureObject.ruleWords.push(
                `This charge does not carry the greatest selected term of incarceration among determinate felonies, and is thus subject to the sentence perscribed by one third of the ${
                  charge.CrimeTypeId == 5 ? "middle" : "selected"
                } term per PC 1170.1(a).`
              );
              charge.newExposureObject.ruleWordsIds.push(24);
            }
          }
          // charge.newExposureObject.isPrincipal = isPrincipal
          let sortedArrayIndex = sortedArray.findIndex((saChg) => {
            return saChg.countNumber == charge.CountNumber;
          });
          if (
            !principalTies.includes(charge.CountNumber) &&
            sortedArrayIndex !== -1 &&
            sortedArray[sortedArrayIndex].determinate == sortedArray[0].determinate
          ) {
            principalTies.push(charge.CountNumber);
          }
        }

        // console.log(charge.newExposureObject)
      });
    }
    // console.log(principalTies);
    return principalTies;
  },

  convertExpoDaysToString(ndays) {
    // console.log(ndays)
    // console.log(ndays, ndays % 360 == 0, Math.floor(ndays / 360))
    var years = 0,
      months = 0,
      weeks = 0,
      days = 0,
      value = 0;
    if (!isNaN(ndays)) {
      value = ndays;
    }
    let exp;
    if (value == 366) {
      exp = "1y 1d";
      return exp;
    } else if (value == 732) {
      exp = "2y 2d";
      return exp;
    } else if (value == 122) {
      exp = "4m";
      return exp;
    } else if (value >= 0) {
      if (value > 364 || value % 360 == 0) {
        years = Math.floor(value / 360);
        value = years ? value - years * 360 : value;
      } else {
        years = 0;
      }

      if (value >= 30) {
        months = Math.floor((value % 360) / 30);
        value = months ? value - months * 30 : value;
      } else {
        months = 0;
      }

      days = Math.floor(value);
      let y = "";

      y = `${years}y `;

      let m = `${months}m `;
      let w = `${weeks}w `;
      let d = `${days}d `;

      exp = (years > 0 ? y : "") + (months > 0 ? m : "") + (weeks > 0 ? w : "") + (days > 0 ? d : "");
    } else {
      exp = "LWOP";
    }
    return exp;
  },

  formatTriad(charge) {
    let expo = charge.newExposureObject;
    expo.formattedTriad = [];
    expo.triad.forEach((ndays) => {
      let dayString = this.convertExpoDaysToString(ndays);
      if (this.isIndeterminate(charge) && !this.isCZ(dayString) && dayString !== "LWOP") {
        dayString += "- L";
      }
      expo.formattedTriad.push(dayString);
      // return exp
    });
  },

  isIndeterminate(charge) {
    let isIndeterminate = false;
    if (
      // charge.Substitution == "Yes" ||

      charge.newExposureObject?.sexSentenced == true ||
      charge.newExposureObject?.gangSentenced == true ||
      (charge.IsIndeterminate) ||
      (charge.IsLWOP ) ||
      (charge.IsDeath ) ||
      charge?.newExposureObject?.indeterminate > 0 ||
      (charge?.newExposureObject?.specialIndeterminate == "LWOP") ||
      (charge?.newExposureObject?.specialIndeterminate == "DEATH") ||
      // Indeterminate because 3SL
      (charge.CrimeSeverityId == 3 &&
        charge.CrimeTypeId == 5 &&
        (((charge?.IsSerious || charge?.IsViolent) && charge.NumberOfStrikes == "2+") || charge.NumberOfStrikes == "2+S"))
      // Indet because 1SL/2SL
    ) {
      isIndeterminate = true;
    }
    return isIndeterminate;
  },
  /*
        expo = {
            triad: [960, 1440, 2160], => triad in days
            isPrincipal: 1, => 0 = Subordinate, 1 = Principal, 2 = Indeterminate, 3 = Status Enhancement, 4 = Midemeanor/Infraction
            determinate: 1440, => selected triad in days if Determinate
            indeterminate: 9000, => selected triad in days if Indeterminate
        }
    */

  // probationEligibility(charges, selectedCase) {
  //   // console.log("PROBATION ELIGIBILITY");

  //   let probationStatus = 0;
  //   let statutorilyIneligible = false;
  //   let RequiresSpecial = false;
  //   let RequiresSpecialB = false;
  //   let RequiresUnusual = false;
  //   if (charges?.length > 0) {
  //     charges.forEach((chg) => {
  //       // console.log(chg.ProbationLimitation);
  //       if (chg.ChargeStatus == 0) {
  //         if (chg.ProbationLimitation == 1 || chg.NumberOfStrikes !== "0") {
  //           probationStatus = 1;
  //         } else if (chg.ProbationLimitation !== 0 && probationStatus !== 4) {
  //           // console.log(chg.ProbationLimitation);
  //           if (chg.ProbationLimitation == 2 || chg.ProbationLimitation == 3) {
  //             RequiresUnusual = true;
  //           }
  //           if (chg.ProbationLimitation == 4 || chg.ProbationLimitation == 3) {
  //             RequiresSpecial = true;
  //           }
  //           if (chg.ProbationLimitation == 5) {
  //             RequiresSpecialB = true;
  //           }
  //           // this.probationStatus = chg.ProbationLimitation
  //         }
  //       }
  //     });
  //   }
  //   // console.log(selectedCase);

  //   if (probationStatus !== 1) {
  //     if (RequiresSpecial && RequiresUnusual) {
  //       probationStatus = 3;
  //     } else if (RequiresSpecial) {
  //       probationStatus = 4;
  //     } else if (RequiresUnusual) {
  //       probationStatus = 2;
  //     } else if (RequiresSpecialB) {
  //       probationStatus = 5;
  //     }
  //   }
  //   // console.log(probationStatus);
  //   return probationStatus;
  // },

  isMisdemeanorSubstitutedToAFelony(chg, charges) {
    const substitution = charges?.filter((charge) => {
      return charge.CountNumber == chg.CountNumber && charge.CrimeTypeId == 2 && charge.ChargeStatus == 0;
    });
    if (substitution.length > 0) {
      if (substitution[0].CrimeSeverityId == 3) {
        return true;
      }
    }
    return false;
  },

  handleConcurrency(charges) {
    let convictedCharges = charges.filter((charge) => charge.ChargeStatus == 0 && charge.CrimeTypeId > 4);
    if (convictedCharges.length) {
      charges.forEach((charge) => {
        // Only the principal (isPrincipal 1/6) and mandatory-consecutive charges are
        // forced consecutive; everyone else uses their stored Concurrency. The principal
        // is the anchor, identified by getPrincipalCharge (which honors the user's
        // Preferred pick), so we no longer compute a separate "biggest charge" — that
        // diverged from the real principal and, when all charges were concurrent, forced
        // the wrong charge consecutive. charge.Concurrency is never mutated.
        charge.newExposureObject.concurrent = effectiveConcurrent(charge);
      });
    }
  },

  // Mirror each changeable enhancement's concurrency to its base charge when the base's
  // concurrency changes (see chargeControlHelpers.syncEnhancementConcurrency). Must run
  // after handleConcurrency (effective concurrency set) and before the final
  // enhancementSweep (so the Mustafaa stay-rule sees matched concurrency). Returns the
  // children whose stored Concurrency changed so onCalc can persist them.
  syncEnhancementConcurrency(charges) {
    return syncEnhConcurrency(charges);
  },

  sentencing(charges, startDate, selectedCase) {
    let notifications = [];
    let basePrincipalTerm = 0;
    let conductPrincipalTerm = 0;
    let misdemeanor = 0;
    let subordinateTermBases = 0;
    let subordinateTermEnhancements = 0;
    // 667.6 (Violent Sex Crime) full-term charges are pulled out of the principal buckets and
    // reported on their own rows: bases and their conduct enhancements separately.
    let sixSevenSixBases = 0;
    let sixSevenSixEnhancements = 0;
    let statusEnhancements = 0;
    let conductEnhancements = 0;
    let totalIndeterminate = 0;
    let totalExpectedSentence = 0;
    let maxConcurrentTerm = 0;
    let lwop = false;
    let death = false;
    let futureCredits = null;
    // Filters for determinate charges for Status enh match check after indeterminate charges reconciled
    // let determinateCharges = charges.filter(chg => chg.newExposureObject?.isPrinciple == 0 || chg.newExposureObject?.isPrinciple == 0)
    charges.forEach((chg) => {
      // console.log(chg.CountNumber, chg.newExposureObject)
      /* Handles hard life sentences */
      if (chg.newExposureObject?.specialIndeterminate && chg.ChargeStatus == 0) {
        if (
          (chg.IsLWOP && chg.CrimeState !== "Attempt") ||
          chg.newExposureObject.specialIndeterminate == "LWOP" ||
          chg.newExposureObject.specialIndeterminate == "DEATH"
        ) {
          lwop = true;
        }
        if ((chg.IsDeath && chg.CrimeState !== "Attempt") || chg.newExposureObject.specialIndeterminate == "DEATH") {
          if (chg.SelectedTerm == 1) {
            lwop = true;
          } else {
            death = true;
          }
        }
      } else if (chg.ChargeStatus == 0) {
        /* keeps track of conduct enhancements even if parent charge is indeterminate */
        // if (chg.CrimeTypeId == 6 && chg.newExposureObject.isPrincipal > 1) {
        //   // console.log("chg", chg.CountNumber);
        //   subordinateTermEnhancements += chg.newExposureObject.determinate;
        // }
        /* Applies Status Enhancements Base */
        if (chg.newExposureObject.isPrincipal == 3) {
          let chargesFiltered = charges;
          // CHECK HERE PLEASE
          if (selectedCase?.caseAttributes?.tomsStupidRule !== false) {
            chargesFiltered = charges.filter(
              (chg) =>
                chg?.CrimeTypeId == 5 &&
                (chg?.newExposureObject?.isPrincipal < 2 ||
                chg?.newExposureObject?.isPrincipal == 6 ||
                chg?.newExposureObject?.isPrincipal == 4)
            );
          }
          if (this.calculateEnhMatch(false, chg.EnhancementMatchGroups, chargesFiltered)) {
            statusEnhancements += chg.newExposureObject.determinate;
          } else {
            chg.newExposureObject.show
          }
          // if (this.calculateEnhMatch(false, chg.EnhancementMatchGroups, determinateCharges)) {

          // }
        } else if (chg.newExposureObject.isPrincipal == 2) {
          if (!chg.newExposureObject?.concurrent) {
            /* applies Tom's stupid Status Enhancement rule to indeterminate charges */

            totalIndeterminate += chg.newExposureObject.indeterminate;
            if (chg.CrimeTypeId == 5 && selectedCase?.caseAttributes?.tomsStupidRule !== false) {
              charges.forEach((enh) => {
                if (
                  enh.CrimeTypeId == 1 &&
                  enh.ChargeStatus == 0 &&
                  // enh.CrimeId !== 2056 &&
                  this.calculateEnhMatch(chg, enh.EnhancementMatchGroups, charges)
                ) {
                  // notifications.push(`${enh.SectionNumber} applied to ${chg.SectionNumber} per Indeterminate Sentencing Law (see People v. Misa (2006) and People v Wells (2004))`)
                  statusEnhancements += enh.newExposureObject.determinate;
                  chg.newExposureObject.determinate += enh.newExposureObject.determinate;
                  if (
                    !chg.newExposureObject.ruleWords.includes(
                      `\n This charge is indeterminate and is not subject to the application of enhancements under PC 1170.1, and thus each status enhancement is applied an additional time to qualifying indeterminate charges. See People v. Wells, No. F050968 (Cal. Ct. App. Nov. 28, 2007), People v. Misa, 140 Cal.App.4th 837, 44 Cal. Rptr. 3d 805 (Cal. Ct. App. 2006)`
                    )
                  )
                    chg.newExposureObject.ruleWords.push(
                      `\n This charge is indeterminate and is not subject to the application of enhancements under PC 1170.1, and thus each status enhancement is applied an additional time to qualifying indeterminate charges. See People v. Wells, No. F050968 (Cal. Ct. App. Nov. 28, 2007), People v. Misa, 140 Cal.App.4th 837, 44 Cal. Rptr. 3d 805 (Cal. Ct. App. 2006)`
                    );
                }
              });
            } else if (chg.CrimeTypeId == 6) {
              // A 667.6 base's conduct enhancement can be classified isPrincipal 2 (when
              // SubordinateSTIRTerm != 3) and land here; route it to the 667.6 bucket instead
              // of the principal conduct-enhancement bucket. A genuine indeterminate charge's
              // enhancement (base isPrincipal 2) stays in conductPrincipalTerm.
              if (isSixSevenSixEnhancement(chg, charges)) {
                sixSevenSixEnhancements += chg.newExposureObject.determinate;
              } else {
                conductPrincipalTerm += chg.newExposureObject.determinate;
              }
            }
          }
        } else if (chg.newExposureObject.isPrincipal == 1 || chg.newExposureObject.isPrincipal == 6) {
          /* handles principal determinate charge + conduct enhancements */
          if (!chg.newExposureObject?.concurrent) {
            if (chg.CrimeTypeId == 5) {
              chg.newExposureObject.determinate = chg.newExposureObject.triad[chg.SelectedTerm - 1];
              // A 667.6 base (isPrincipal 6) is reported on its own row, out of the principal base.
              if (chg.newExposureObject.isPrincipal == 6) {
                sixSevenSixBases += chg.newExposureObject.determinate;
              } else {
                basePrincipalTerm += chg.newExposureObject.determinate;
              }
            } else if (chg.CrimeTypeId == 6) {
              const parentCharge = charges.find(
                (element) => element.CountNumber == chg.CountNumber && element.CrimeTypeId == 5
              );
              if (
                parentCharge &&
                (parentCharge.RunSTIRCalculation == true || chg.RunSTIRCalculation) &&
                parentCharge.newExposureObject.isPrincipal == 6
              ) {
                // Conduct enhancement of a 667.6 base — its own 667.6 row, not principal conduct.
                chg.newExposureObject.determinate = stirEnhancementDeterminate(parentCharge, chg);
                sixSevenSixEnhancements += chg.newExposureObject.determinate;
              } else {
                chg.newExposureObject.determinate = chg.newExposureObject.triad[chg.SelectedTerm - 1];
                conductPrincipalTerm += chg.newExposureObject.determinate;
              }
            }
          } else if (chg.newExposureObject?.concurrent) {
            // A concurrent 667.6/principal-role charge still runs — its full selected term
            // counts toward the longest concurrent term, which extends the sentence when it
            // exceeds the consecutive block. (Previously such charges fell into the dead
            // commented block below and contributed nothing.)
            if (chg.CrimeTypeId == 5) {
              chg.newExposureObject.determinate = chg.newExposureObject.triad[chg.SelectedTerm - 1];
            }
            if (chg.newExposureObject.determinate > maxConcurrentTerm) {
              maxConcurrentTerm = chg.newExposureObject.determinate;
              chg.newExposureObject.ruleWords.push(
                `This charge is ordered to run concurrent per the user's selection; its full term is served concurrently.`
              );
            }
          }
          // else if (chg.Concurrency) {
          // // console.log('Concurrent Term found')
          //     notifications.push(`${chg.SectionNumber} is considered a Principal Term because it is a Concurrent Charge`)
          //     if (chg.newExposureObject.determinate > maxConcurrentTerm) {
          //         maxConcurrentTerm = chg.newExposureObject.determinate
          //     } else {
          //     // console.log(chg.newExposureObject.determinate > maxConcurrentTerm)
          //     }
          // }
          // & Handles misdemeanors and infractions
        } else if (chg.newExposureObject.isPrincipal == 4) {
          /* handles misdemeanors and infractions */
          // console.log("MISD SENTENCING", chg.newExposureObject);

          if (!chg.newExposureObject?.concurrent) {
            if (chg.ProbationJailTimeDays >= chg.newExposureObject.determinate) {
              chg.ProbationJailTimeDays = chg.newExposureObject.determinate;
              this.postChargeField(
                localStorage.getItem("user_token"),
                chg.Id,
                "ProbationJailTimeDays",
                chg.ProbationJailTimeDays
              );
            }
            if (
              chg.ProbationJailTimeDays !== null &&
              chg.ProbationJailTimeDays !== undefined &&
              chg.ProbationJailTimeDays > 0
            ) {
              chg.newExposureObject.determinate = chg.ProbationJailTimeDays;
              misdemeanor += chg.ProbationJailTimeDays;
            } else {
              misdemeanor += chg.newExposureObject.determinate;
            }
          }
          // & Handles subordinate charges
        } else if (chg.newExposureObject.isPrincipal == 0) {
          if (!chg.newExposureObject?.concurrent) {
            if (chg.CrimeTypeId == 5) {
              // & Handles Misdemeanors Subbed to a Felony by 186.22(d)
              if (chg.CrimeSeverityId == 2 && this.isMisdemeanorSubstitutedToAFelony(chg, charges)) {
                chg.newExposureObject.determinate = (1 / 3) * chg.newExposureObject.triad[1];
                subordinateTermBases += chg.newExposureObject.determinate;
                // & Handles completed felonies
              } else if (chg.CrimeState !== "Attempt") {
                const stirFactor = chg?.RunSTIRCalculation == true ? chg.SubordinateSTIRFactor : 3;
                let stirTerm = 2
                if (chg?.RunSTIRCalculation == true && chg.SubordinateSTIRTerm == 3) {
                  stirTerm = chg.SelectedTerm
                }
                // if (chg?.RunSTIRCalculation == true && chg.SubordinateSTIRTerm == 3) {
                //   chg.SelectedTerm = stirTerm;
                // }
                chg.newExposureObject.triad.forEach((term) => {
                  return (term *= 1 / stirFactor);
                });
                // console.log(chg.CountNumber, stirFactor);
                if (stirFactor !== 3) {
                  notifications.push(
                    `${chg.SectionNumber} receive a full term sentence despite being subordinate, per definition`
                  );
                  chg.newExposureObject.ruleWords.push(
                    `This charge is not subject to a sentence of 1/3 of the Middle Term.`
                  );
                }
                chg.newExposureObject.determinate = (1 / stirFactor) * chg.newExposureObject.triad[stirTerm - 1];
                subordinateTermBases += chg.newExposureObject.determinate;
                // & Handles attempted subordinate charges, because all subordinate attempts are 1/3 of the middle term
              } else if (chg.CrimeState == "Attempt") {
                chg.newExposureObject.determinate = chg.newExposureObject.triad[1] / 3;
                subordinateTermBases += chg.newExposureObject.determinate;
              }

              // & Handles conduct enhancements of subordinate charges
            } else if (chg.CrimeTypeId == 6) {
              let stirFactor = 3;
              if (
                chg?.parentCharge?.RunSTIRCalculation == true &&
                (chg?.parentCharge?.EnhancementSTIRFactor !== 3 || chg?.EnhancementSTIRFactor !== 3)
              ) {
                // console.log("CHANGES STIR FACTOR", chg.parentCharge, stirFactor);
                stirFactor =
                  chg?.parentCharge?.EnhancementSTIRFactor !== 3
                    ? chg?.parentCharge?.EnhancementSTIRFactor
                    : chg?.EnhancementSTIRFactor;
                // console.log(stirFactor);
              }
              chg.newExposureObject.triad.forEach((term) => (term *= 1 / stirFactor));
              if (chg.parentCharge?.EnhancementSTIRFactor !== 3) {
                notifications.push(
                  `${chg.SectionNumber} receive a full term sentence despite being subordinate, because the charge it's attached to mandates a full term for enhancements`
                );
                chg.newExposureObject.ruleWords.push(
                  `This enhancement is not subject to a sentence of 1/3 of the Selected Term.`
                );
              }
              chg.newExposureObject.determinate *= 1 / stirFactor;
              subordinateTermEnhancements += chg.newExposureObject.determinate;
              // console.log(subordinateTermEnhancements);
            }
          } else if (chg.newExposureObject?.concurrent) {
            // console.log('Concurrent Term found')

            if (chg.newExposureObject.determinate > maxConcurrentTerm) {
              maxConcurrentTerm = chg.newExposureObject.determinate;
              chg.newExposureObject.ruleWords.push(
                `This charge is ordered to run concurrent to the Principal charge per the user's selection.`
              );
            } else {
              // console.log(chg.newExposureObject.determinate > maxConcurrentTerm);
            }
          }
        }
      }
      if (chg.ChargeStatus == 0) {
        if (futureCredits == null) {
          futureCredits =
            chg.CrimeSeverityId == 3 && chg.ChargeStatus == 0
              ? chg.newExposureObject.pcredit
              : chg.newExposureObject.jcredit;
        } else {
          // console.log(futureCredits, chg?.CountNumber);
          let currentCred =
            chg.CrimeSeverityId == 3 && chg.ChargeStatus == 0
              ? chg.newExposureObject.pcredit
              : chg.newExposureObject.jcredit;
          if (futureCredits > currentCred) {
            futureCredits = currentCred;
          }
        }
      }

      // chg.newExposureObject.expectedSentence = this.convertExposureToRealDays(chg.newExposureObject.determinate + chg.newExposureObject.indeterminate) * (1- ((100 - (chg.CrimeSeverityId == 3)?chg.newExposureObject.pcredit:chg.newExposureObject.jcredit) / 100));
      // console.log(chg.newExposureObject.pcredit, chg.newExposureObject.expectedSentence, ((100 - (chg.CrimeSeverityId == 3)?chg.newExposureObject.pcredit:chg.newExposureObject.jcredit) / 100))
      // totalExpectedSentence += chg.newExposureObject.expectedSentence
      this.formatTriad(chg);
      // console.log(chg.Id, chg.SectionNumber, chg.newExposureObject)
    });
    // console.log("FUTURE CREDITS", futureCredits);
    let totalPrincipalTerm = basePrincipalTerm + conductPrincipalTerm;
    // console.log(totalPrincipalTerm);
    // A concurrent charge extends the sentence only when it runs past the consecutive
    // block, so the determinate total is the longer of the two.
    // 667.6 consecutive terms add into the aggregate exactly like the principal/subordinate
    // consecutive terms; concurrent 667.6 charges reach the total only via maxConcurrentTerm
    // (below), same as every other concurrent term.
    let consecutiveDeterminate =
      totalPrincipalTerm +
      subordinateTermBases +
      subordinateTermEnhancements +
      sixSevenSixBases +
      sixSevenSixEnhancements +
      statusEnhancements;
    let totalDeterminate = combineDeterminateTotal(consecutiveDeterminate, maxConcurrentTerm);
    let finalExposureObject = {
      basePrincipalTerm: basePrincipalTerm,
      conductPrincipalTerm: conductPrincipalTerm,
      misdemeanor: misdemeanor,
      maxConcurrentTerm: maxConcurrentTerm,
      subordinateTermBases: subordinateTermBases,
      subordinateTermEnhancements: subordinateTermEnhancements,
      sixSevenSixBases: sixSevenSixBases,
      sixSevenSixEnhancements: sixSevenSixEnhancements,
      statusEnhancements: statusEnhancements,
      totalPrincipalTerm: totalPrincipalTerm,
      totalConductEnhancements: conductEnhancements,
      totalDeterminate: totalDeterminate,
      totalIndeterminate: totalIndeterminate,
      lwop: lwop,
      death: death,
      totalExpectedSentence: (totalDeterminate + totalIndeterminate) * ((100 - futureCredits) / 100),
      futureCredits: futureCredits,
    };
    let displayExpoObject = {
      basePrincipalTerm: { days: 0, months: 0, years: 0, rawDays: 0 },
      conductPrincipalTerm: { days: 0, months: 0, years: 0, rawDays: 0 },
      subordinateTermBases: { days: 0, months: 0, years: 0, rawDays: 0 },
      subordinateTermEnhancements: { days: 0, months: 0, years: 0, rawDays: 0 },
      sixSevenSixBases: { days: 0, months: 0, years: 0, rawDays: 0 },
      sixSevenSixEnhancements: { days: 0, months: 0, years: 0, rawDays: 0 },
      statusEnhancements: { days: 0, months: 0, years: 0, rawDays: 0 },
      totalDeterminate: { days: 0, months: 0, years: 0, rawDays: 0 },
      totalIndeterminate: { days: 0, months: 0, years: 0, rawDays: 0 },
      totalConductEnhancements: { days: 0, months: 0, years: 0, rawDays: 0 },
      misdemeanor: { days: 0, months: 0, years: 0, rawDays: 0 },
    };
    Object.keys(displayExpoObject).forEach((key) => {
      let rawDays = finalExposureObject[key];
      displayExpoObject[key].years = Math.floor(rawDays / 360);
      displayExpoObject[key].months = Math.floor((rawDays % 360) / 30);
      displayExpoObject[key].days = Math.floor((rawDays % 360) % 30);
      displayExpoObject[key].rawDays = rawDays;
    });
    // console.log(displayExpoObject);
    // console.log(finalExposureObject);
    // console.log(
    //   "TOTAL EXPECTED SENTENCE",
    //   this.convertExposureToRealDays(totalDeterminate + totalIndeterminate) *
    //     ((100 - futureCredits) / 100)
    // );
    // console.log(finalExposureObject);

    const rdObj = this.calculateTrueReleaseDate(startDate, displayExpoObject, futureCredits);
    return {
      finalExposureObject: finalExposureObject,
      notifications: notifications,
      displayExpoObject: displayExpoObject,
      fullSentence: rdObj.fullSentenceDays,
      releaseDate: rdObj.releaseDate,
    };
  },

  calculateTrueReleaseDate(startDate, formattedExpoObj, pcredit) {
    // console.log("RELEASE DATE");
    // console.log("PCREDIT", pcredit);
    let releaseDate = new moment(startDate);
    let hardStart = startDate ? new moment(startDate) : new moment();
    if (!startDate) {
      releaseDate = new moment();
    }
    let totalDays = 0;
    let prisonDays = 0;
    let jailDays = 0;
    releaseDate.add(formattedExpoObj.totalDeterminate.years, "years");
    releaseDate.add(formattedExpoObj.totalDeterminate.months, "months");
    releaseDate.add(formattedExpoObj.totalDeterminate.days, "days");
    releaseDate.add(formattedExpoObj.totalIndeterminate.years, "years");
    releaseDate.add(formattedExpoObj.totalIndeterminate.months, "months");
    releaseDate.add(formattedExpoObj.totalIndeterminate.days, "days");
    releaseDate.add(formattedExpoObj.misdemeanor.rawDays, "days");

    let millisecondSentence = releaseDate.diff(hardStart);
    const fullSentenceDays = Math.floor(millisecondSentence / (1000 * 3600 * 24));
    // console.log("days", Math.floor(millisecondSentence / (1000 * 3600 * 24)));
    // console.log(pcredit !== false);

    // console.log("releastDate:", releaseDate.format("MM/DD/YYYY"));

    let returnObj = {
      fullSentenceDays: fullSentenceDays,
      releaseDate: releaseDate.format("MM/DD/YYYY"),
      // earliestReleaseDate: earliestReleaseDate.format("MM/DD/YYYY"),
    };
    if (pcredit !== false) {
      const daysToSubstract = Math.floor(((100 - pcredit) / 100) * fullSentenceDays);
      // console.log(daysToSubstract);
      let earliestReleaseDate = releaseDate.subtract(daysToSubstract, "days");
      // console.log(earliestReleaseDate.format("MM/DD/YYYY"));
      returnObj.earliestReleaseDate = earliestReleaseDate.format("MM/DD/YYYY");
    }
    return returnObj;
  },

  // convertExposureToRealDays(expo) {
  //   // console.log('EXPO DAYS', expo)
  //   let days = 0;
  //   if (expo % 360 == 0) {
  //     days += (expo / 360) * 365;
  //   } else {
  //     let years = expo - (expo % 360);
  //     let months = expo % 360;
  //     days += (years / 360) * 365 + months;
  //   }
  //   // console.log(days);
  //   return days;
  // },

  // expectedDismissals(charges){

  // },

  // smartExposure(normalCharges, direction, weirdStirCharges) {
  //     // console.log('SMART EXPOSURE')
  //     if (direction == 'max') {
  //     // console.log(normalCharges)
  //     // console.log(weirdStirCharges)
  //         // mutates and calculates the normal charges so it can see their exposure
  //         this.threeStrikeFormula(normalCharges)
  //         this.getPrincipalCharge(normalCharges);
  //         this.sentencing(normalCharges);
  //     // console.log(normalCharges)
  //         // gets principal term from formatted charges
  //         let maxPrincipal = 0
  //         // accounts for enhancements attached to principal charge
  //         normalCharges.forEach(chg => {
  //             if (chg.newExposureObject?.isPrincipal == 1) {
  //                 maxPrincipal += chg.newExposureObject.determinate
  //             }
  //         })
  //     // console.log('Max Principal: ', maxPrincipal)
  //         // Creates an array of objects containing the triad for the parent charge as well as a triad for each enhancement
  //         let weirdStirTempTriad = []
  //         weirdStirCharges.forEach(wsc => {
  //             let tempTriadIndex = weirdStirTempTriad.findIndex(chg => chg.CountNumber == wsc.CountNumber)
  //             // Checks if there's already an object for the count number, and if there isn't makes a new one for the crime, and then
  //             if (wsc.ChargeStatus == 0) {
  //                 if (tempTriadIndex == -1) {
  //                     weirdStirTempTriad.push({
  //                         CountNumber: wsc.CountNumber,
  //                         CrimeTriad: [wsc.LowerTermLength * wsc.LowerTermUnits, wsc.MiddleTermLength * wsc.MiddleTermUnits, wsc.UpperTermLength * wsc.UpperTermUnits,]
  //                     })
  //                 } else if (wsc.CrimeTypeId == 6) {
  //                     if (weirdStirTempTriad[tempTriadIndex]?.EnhancementTriad?.length) {
  //                         weirdStirTempTriad[tempTriadIndex]?.EnhancementTriad?.push([wsc.LowerTermLength * wsc.LowerTermUnits, wsc.MiddleTermLength * wsc.MiddleTermUnits, wsc.UpperTermLength * wsc.UpperTermUnits,])
  //                     } else if (weirdStirTempTriad[tempTriadIndex]?.EnhancementTriad == undefined) {
  //                         weirdStirTempTriad[tempTriadIndex].EnhancementTriad = []
  //                         weirdStirTempTriad[tempTriadIndex].EnhancementTriad?.push([wsc.LowerTermLength * wsc.LowerTermUnits, wsc.MiddleTermLength * wsc.MiddleTermUnits, wsc.UpperTermLength * wsc.UpperTermUnits,])

  //                     }
  //                 }
  //             }
  //         })
  //         // console.log('WSC TEMP TRIAD', weirdStirTempTriad)
  //         // Loops over the exposure object array of WSCs to compare to the max charge and finds max exposure for each wsc
  //         let wscMaxTerms = [];
  //         weirdStirTempTriad.forEach(count => {
  //             let determinate = 0;
  //             // sets minimum at lowerterm to see if this calculation even matters first, or UT if no LT defined
  //             let minimum = count.CrimeTriad[0] != 0?count.CrimeTriad[0]:count.CrimeTriad[2];
  //             let tryingTriad = [0]
  //             if (count?.EnhancementTriad?.length > 0) {
  //                 count?.EnhancementTriad.forEach(enhTriad => {
  //                     minimum += enhTriad[0];
  //                     tryingTriad.push(0)

  //                 })
  //             };
  //             //If the minimum combination of crime + enh is bigger than cap, it must be at least in contention for Princiapl, so make it max exposure
  //             if (minimum > maxPrincipal) {
  //                 tryingTriad = tryingTriad.map(i => i = 2)
  //                 wscMaxTerms.push(tryingTriad)
  //             }
  //         })
  //     }
  // },

  checkForUpdates(oldCharges, newCharges, user_token) {
    newCharges.forEach((nc) => {
      let oldCharge = oldCharges.find((oc) => oc.Id == nc.id);
      let id = nc.Id;
    });
  },

  sexCrimesCheck(charges, runSentencing) {
    // console.log("SEX CRIMES CHECK");
    let notifications = [];
    let runSexSentencing = false;
    charges.forEach((chg) => {
      // console.log(chg, chg.IsOneStrikeTrigger > 0 || chg.IsTwoStrikeTrigger > 0);
      if (chg.IsOneStrikeTrigger > 0 || chg.IsTwoStrikeTrigger > 0 || chg.CrimeCategoryId == 26) {
        // console.log(chg);
        runSexSentencing = chg.ChargeStatus === 0;
      }
    });
    if (runSexSentencing && runSentencing) {
      // console.log("RUNS SEX SENTENCING");
      // this.sexCrimesSentencing(charges);
      this.runSexSentencingOccasions(charges);
    }
    // console.log(runSexSentencing);
    return runSexSentencing;
  },

  runSexSentencingOccasions(chgs) {},

  // async betterCCs(caseId, token) {
  //   // console.log(token);
  //   const charges = await axios
  //     .get(process.env.VUE_APP_ENDPOINT + `/api/charges/CaseId/${caseId}`, {
  //       headers: {
  //         Authorization: "Bearer " + token,
  //         "Content-Type": "application/json",
  //       },
  //     })
  //     .then(async (result) => {
  //       let rawCharges = result.data;
  //       let populatedChargesArray = [];
  //       rawCharges.forEach(async (chg) => {
  //         populatedChargesArray.push(
  //           axios
  //             .post(
  //               process.env.VUE_APP_ENDPOINT + "/api/crimeCollateralConsequences/include",
  //               {
  //                 where: {
  //                   CrimeId: chg?.CrimeId,
  //                 },
  //                 include: ["CollateralConsequence"],
  //               },
  //               {
  //                 headers: {
  //                   Authorization: "Bearer " + token,
  //                 },
  //               }
  //             )
  //             .then(async (results) => {
  //               let populatedCrime = chg;
  //               populatedCrime.ccArray = await results.data;
  //               // console.log('******', populatedCrime)
  //               return populatedCrime;
  //             })
  //         );
  //       });
  //       let chargesWithCC = await Promise.allSettled(populatedChargesArray);
  //       // console.log(chargesWithCC)
  //       let completedCharges = chargesWithCC.map((chg) => chg.value);
  //       return completedCharges;
  //     });
  //   // console.log(charges);
  // },

  async applySubstitutions(charges) {
    // console.log("SUB");
    let currentCrimeIndex = 0;
    charges.forEach((chg, index) => {
      if (chg.CrimeTypeId == 5) {
        currentCrimeIndex = index;
      } else if (chg.CrimeTypeId == 2 && chg.ChargeStatus == 0) {
        // console.log("SUBSTITUTION ENH: ", chg);
        if (this.isIndeterminate(chg)) {
          if (this.calculateEnhMatch(charges[currentCrimeIndex], chg.EnhancementMatchGroups, charges, chg)) {
            if (chg.CrimeState !== "Attempt" && chg.CrimeTypeId == 2) {
              charges[currentCrimeIndex].newExposureObject.EnhancedLWOP = chg.IsLWOP;
              charges[currentCrimeIndex].newExposureObject.EnhancedDeath = chg.IsDeath;
            }

            if (chg.newExposureObject.triad[2] < 0) {
              // console.log("Sub Object: ", chg);
              // console.log("Parent Charge: ", charges[currentCrimeIndex]);
              charges[currentCrimeIndex].newExposureObject.triad = chg.newExposureObject.triad;
              charges[currentCrimeIndex].newExposureObject.indeterminate = chg.newExposureObject.triad[2];
              chg.newExposureObject.triad = [0, 0, 0];
              // charges[currentCrimeIndex].SelectedTerm = chg.SelectedTerm
              // chg.newExposureObject.triad = [0, 0, 0];
              // console.log("Parent Charge: ", charges[currentCrimeIndex]);
            } else if (
              chg.IsDeath &&
              charges[currentCrimeIndex].CrimeState !== "Attempt" &&
              charges[currentCrimeIndex].SelectedTerm == 3
            ) {
              // console.log("DEATH BY SUB");
              charges[currentCrimeIndex].newExposureObject.specialIndeterminate = "DEATH";
            } else if (chg.IsLWOP && charges[currentCrimeIndex].CrimeState !== "Attempt") {
              // console.log("DEATH BY SUB");
              charges[currentCrimeIndex].newExposureObject.specialIndeterminate = "LWOP";
            } else {
              charges[currentCrimeIndex].newExposureObject.triad = chg.newExposureObject.triad;
              const indetTerm = chg.newExposureObject.triad[2];
              charges[currentCrimeIndex].newExposureObject.determinate = 0;
              charges[currentCrimeIndex].newExposureObject.indeterminate = indetTerm;
              charges[currentCrimeIndex].SelectedTerm = 3;
              chg.newExposureObject.triad = [0, 0, 0];
            }
          } else {
            chg.ChargeStatus = 4;
          }
        } else {
          const parentCharge = charges[currentCrimeIndex];
          if (parentCharge.CrimeTypeId == 5) {
            // console.log("PARENT CHARGE", parentCharge);
            if (this.calculateEnhMatch(parentCharge, chg.EnhancementMatchGroups, charges, chg)) {
              parentCharge.newExposureObject.minJailTime = chg.newExposureObject.minJailTime;
              parentCharge.newExposureObject.maxJailTime = chg.newExposureObject.maxJailTime;
              parentCharge.newExposureObject.ruleWords = chg.newExposureObject.ruleWords;
              parentCharge.newExposureObject.populatedRuleWords = chg.newExposureObject.populatedRuleWords;
              parentCharge.newExposureObject.jcredit = chg.newExposureObject.jcredit;
              parentCharge.newExposureObject.pcredit = chg.newExposureObject.pcredit;
              parentCharge.newExposureObject.triad = chg.newExposureObject.triad;
              parentCharge.newExposureObject.determinate = chg.newExposureObject.determinate;
              parentCharge.newExposureObject.indeterminate = chg.newExposureObject.indeterminate;
              parentCharge.newExposureObject.specialIndeterminate = chg.newExposureObject.specialIndeterminate;
              parentCharge.newExposureObject.isPrincipal = chg.newExposureObject.isPrincipal;
              parentCharge.newExposureObject.ruleWordsIds = chg.newExposureObject.ruleWordsIds;
              parentCharge.newExposureObject.dotsonOptions = chg.newExposureObject.dotsonOptions;
            } else {
              chg.ChargeStatus = 4;
            }
          }
        }
      }
    });
  },

  convertExposureToDays(expo) {
    // console.log("EXPO DAYS", expo);
    let days = 0;
    if (expo % 360 == 0) {
      days += (expo / 360) * 365;
    } else {
      let years = expo - (expo % 360);
      let months = expo % 360;
      days += (years / 360) * 365 + months;
    }
    // console.log(days);
    return days;
  },

  gangSentencing(charges) {
    const notifs = [];
    // console.log("GANG SENTENCING");
    /*8718
8722
8738
8742
8745
8747
8770
9149*/
    charges.forEach((chg, index) => {
      // console.log(index, chg)
      // if (chg?.isGang == true) {
      //   // console.log("FIND A GANG CHARGE");
      //   if (this.isIndeterminate(chg)) {
      //     if (chg?.Category3 == "Murder") {
      //       // console.log("Add a 190.2", chg);
      //       notifs.push(
      //         `If Count ${chg.CountNumber} has been pled and proven to be for the benefit of, at the direction of, or in association with a criminal street gang, with the specific intent to promote, further, or assist in criminal conduct by gang members, please add a charge for a PC 190.2(a)(22) to Count ${chg.CountNumber}`
      //       );
      //     } else {
      //       let newTriad = chg.newExposureObject.triad.map((term) => {
      //         // console.log(term);
      //         if (term < 5400 && term !== 0) {
      //           term += 5400 - term;
      //         }
      //         return term;
      //       });
      //       chg.newExposureObject.triad = newTriad;
      //       // console.log(newTriad, chg.newExposureObject.triad);
      //       // console.log("186.22(b)(5)", chg);
      //       notifs.push(
      //         `If Count ${chg.CountNumber} has been pled and proven to be for the benefit of, at the direction of, or in association with a criminal street gang, with the specific intent to promote, further, or assist in criminal conduct by gang members, then it is subject to PC 186.22(b)(5) sentencing.`
      //       );
      //     }
      //   } else if (chg.ChargeStatus == 0) {
      //     let foundB4BEmgIndex = chg.EnhancementMatchGroups.findIndex((emg) => {
      //       return emg.EnhancementMatchGroupId == 87;
      //     });
      //     let foundB4CEmgIndex = chg.EnhancementMatchGroups.findIndex((emg) => {
      //       return emg.EnhancementMatchGroupId == 88;
      //     });
      //     // console.log("EMG INDEXES", foundB4BEmgIndex, foundB4CEmgIndex);
      //     // console.log(chg.newExposureObject);
      //     if (foundB4BEmgIndex > -1 || foundB4CEmgIndex > -1) {
      //       if (foundB4BEmgIndex > -1) {
      //         // console.log("186.22(b)(4)(B)", chg);
      //         let newTriad = chg.newExposureObject.triad.map((term) => {
      //           // console.log(term);
      //           if (term < 5400) {
      //             term += 5400 - term;
      //           }
      //           return term;
      //         });
      //         chg.newExposureObject.triad = newTriad;
      //         notifs.push(
      //           `If Count ${chg.CountNumber} has been pled and proven to be for the benefit of, at the direction of, or in association with a criminal street gang, with the specific intent to promote, further, or assist in criminal conduct by gang members, then it is subject to PC 186.22(b)(4)(B) sentencing.`
      //         );
      //       } else if (foundB4CEmgIndex > -1) {
      //         // console.log("186.22(b)(4)(C)", chg);
      //         let newTriad = chg.newExposureObject.triad.map((term) => {
      //           // console.log(term);
      //           if (term < 2520) {
      //             term += 2520 - term;
      //           }
      //           return term;
      //         });
      //         chg.newExposureObject.triad = newTriad;
      //         notifs.push(
      //           `If Count ${chg.CountNumber} has been pled and proven to be for the benefit of, at the direction of, or in association with a criminal street gang, with the specific intent to promote, further, or assist in criminal conduct by gang members, then it is subject to PC 186.22(b)(4)(C) sentencing.`
      //         );
      //       }
      //       chg.newExposureObject.gangSentenced = true;
      //       // console.log(chg.newExposureObject);
      //     } else if (chg.CrimeSeverityId == 3) {
      //       if (chg.cvgIsViolent) {
      //         notifs.push(
      //           `If Count ${chg.CountNumber} has been pled and proven to be for the benefit of, at the direction of, or in association with a criminal street gang, with the specific intent to promote, further, or assist in criminal conduct by gang members, then it is subject to an additional penalty of 10 years per PC 186.22(b)(1)(C).`
      //         );
      //       } else if (chg.IsSerious) {
      //         notifs.push(
      //           `If Count ${chg.CountNumber} has been pled and proven to be for the benefit of, at the direction of, or in association with a criminal street gang, with the specific intent to promote, further, or assist in criminal conduct by gang members, then it is subject to an additional penalty of 5 years per PC 186.22(b)(1)(B).`
      //         );
      //       } else {
      //         notifs.push(
      //           `If Count ${chg.CountNumber} has been pled and proven to be for the benefit of, at the direction of, or in association with a criminal street gang, with the specific intent to promote, further, or assist in criminal conduct by gang members, then it is subject to an additional penalty of 2, 3, or 4 years per PC 186.22(b)(1)(A).`
      //         );
      //       }
      //     }
      //   }
      // }
    });
    // console.log(notifs);
    return notifs;
  },

  async replaceCharge(chargeToReplace, newCrime, token) {
    const updatedCharge = await this.postChargeField(token, chargeToReplace.Id, "CrimeId", newCrime.Id);
    return;
  },

  violentOffenders(charges, caseData) {
    // console.log("667.7 Sentencing", caseData.ViolentPriors);
    if (caseData.ViolentPriors !== 0) {
      charges.forEach((chg) => {
        if (chg.CrimeSeriousGroupId == 40 && chg.ChargeStatus == 0) {
          if (chg.CrimeTypeId == 5) {
            if (caseData.ViolentPriors == 3) {
              // console.log("4th Strike");
              chg.newExposureObject.specialIndeterminate = "LWOP";
            } else if (caseData.ViolentPriors == 2) {
              // console.log("Two Strikes or Something");
            }
          } else {
            const countNumber = chg.CountNumber;
            const parentChargeIndex = charges.findIndex((pchg) => pchg.CountNumber == countNumber && pchg.CrimeTypeId == 5);
            if (parentChargeIndex !== -1) {
              let pCharge = charges[parentChargeIndex];
              if (caseData.ViolentPriors == 3) {
                // console.log("4th Strike");
                pCharge.newExposureObject.specialIndeterminate = "LWOP";
              } else if (caseData.ViolentPriors == 2) {
                // console.log("Two Strikes or Something");
              }
            }
          }
        }
      });
    }
  },

  isViolent(chg) {
    return (
      chg.ChargeStatus == 0 && (chg.IsViolent || chg.EnhancedViolent)
      // (chg.ChargeStatus == 0 &&
      //   chg.CrimeState == "Completed" &&
      //   (chg.cvgIsViolent || chg.EnhancedViolent)) ||
      // (chg.CrimeState == "Attempt" &&
      //   chg.Name?.toUpperCase().includes("MURDER"))
    );
  },

  isSerious(chg) {
    return (
      chg.CrimeSeverityId == 3 &&
      chg.ChargeStatus == 0 &&
      // (chg.CrimeState == "Completed" ||
      //   (chg.CrimeState == "Attempt" &&
      //     !chg.Name?.toUpperCase().includes("ASSAULT")) ||
      //   chg.CrimeState == "Conspiracy") &&
      // (chg.IsSerious || chg.EnhancedSerious)
      (chg.IsSerious || chg.EnhancedSerious)
    );
  },

  isStrike(chg) {
    return this.isViolent(chg) || this.isSerious(chg);
  },
  ageAtOffense(dob, date) {
    // console.log("DOB", dob, "Date", date);
    const dobUTC = moment(dob, "YYYY-MM-DD");
    const dateUTC = moment(date, "YYYY-MM-DD");
    let ageAtObj = {
      years: dateUTC.diff(dobUTC, "years"),
      months: dateUTC.diff(dobUTC, "months") - dateUTC.diff(dobUTC, "years") * 12,
    };
    return ageAtObj;
  },
  displayFormattedSentence(chg) {
    const chargeStatusArray = ["Convicted", "Acquitted", "Dismissed", "Stayed", "Stayed", "Stayed", "Stayed"];
    let sentenceString = "";
    const expo = chg.newExposureObject;
    if (chg.ChargeStatus == 0) {
      if (!expo?.specialIndeterminate) {
        if (expo?.determinate) {
          const det = this.convertExpoDaysToString(expo.determinate);
          sentenceString += det;
        }
        if (expo?.determinate && expo?.indeterminate) {
          sentenceString += " + ";
        }
        if (expo?.indeterminate) {
          const indet = this.convertExpoDaysToString(expo.indeterminate);
          sentenceString += indet + "- L";
        }
      } else {
        if (expo.specialIndeterminate == "DEATH") {
          if (chg.SelectedTerm == 1) {
            sentenceString = "LWOP";
          } else {
            sentenceString = "DEATH";
          }
        } else if (expo.specialIndeterminate == "LWOP") {
          sentenceString = "LWOP";
        }
      }
    } else {
      sentenceString = chargeStatusArray[chg.ChargeStatus];
    }
    if (chg.newExposureObject?.concurrent) {
      sentenceString += "(CC)";
    }
    return sentenceString;
  },
};
</script>

<style></style>
